import { on } from 'delegated-events'
import scrollTo from '@common/scroll-to'

on('click', '.element-expandablecontent a[title="Show content"]', (e) => {
  e.preventDefault()

  const element = e.target.closest('.element-expandablecontent')

  const trigger = element.querySelector('.expand-content-trigger')

  if (trigger) {
    if (trigger.getAttribute('aria-expanded') === 'false') {
      trigger.click()
    } else {
      scrollTo(document.getElementById(trigger.getAttribute('aria-controls')))
    }
  }
})
